module.exports = __webpack_public_path__ + "static/img/about_bg.9b0967c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_bg.png
// module id = iLzN
// module chunks = 0